import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="date-formatter"
export default class extends Controller {
  connect() {
    const element = $(this.element);
    window.dateConvertor(element);
  }
}
